export const PERMISSION = {
  // DASHBOARD: {
  //   DASHBOARDREPORT: {
  //     ATDREPORT: {
  //       VIEW: "ATD_NEW_TEST-DASHBOARD-ALL RIGHTS-ATD::DASHBOARD"
  //     }
  //   }
  // },
  DASHBOARD: {
    DASHBOARD: {
      VIEW: "ATD DASHBOARD-DASHBOARD-VIEW-LOGIN :: DASHBOARD :: VIEW",
      DATAWISEREPORT: {
        VIEW: "ATD DASHBOARD-DASHBOARD-VIEW-LOGIN :: DASHBOARD :: DATA WISE REPORT",
      },
      IMPRESSIONGRAPH: {
        VIEW: "ATD DASHBOARD-DASHBOARD-VIEW-LOGIN :: DASHBOARD :: IMPRESSION GRAPH",
      },
      STATISTICS: {
        VIEW: "ATD DASHBOARD-DASHBOARD-VIEW-LOGIN :: DASHBOARD :: STATISTICS",
      },
      CAMPAIGNPERFORMANCEVIEW: {
        VIEW: "ATD DASHBOARD-DASHBOARD-VIEW-LOGIN :: DASHBOARD :: CAMPAIGN PERFORMANCE VIEW",
      },
      CAMPAIGNVIEW: {
        // VIEW: "ATD DASHBOARD-DASHBOARD-VIEW-LOGIN :: DASHBOARD :: VIEW",
        VIEW: "ATD DASHBOARD-DASHBOARD-STRATEGY VIEW-LOGIN :: DASHBOARD :: CAMPAIGN REPORT :: STRATEGY VIEW"
        //  access to the Strategy View report

      },
      CAMPAIGNREPORTVIEW: {
        // VIEW: "ATD DASHBOARD-DASHBOARD-VIEW-LOGIN :: DASHBOARD :: VIEW",
        VIEW: "ATD DASHBOARD-DASHBOARD-CAMPAIGN VIEW-LOGIN :: DASHBOARD :: CAMPAIGN REPORT :: CAMPAIGN VIEW",
        //Only access to the campaign wise report
      },
      IOREPORTVIEW: {
        // VIEW: "ATD DASHBOARD-DASHBOARD-VIEW-LOGIN :: DASHBOARD :: VIEW",
        VIEW: "ATD DASHBOARD-DASHBOARD-IO VIEW-LOGIN :: DASHBOARD :: CAMPAIGN REPORT :: IO VIEW",
        //Only access to the IO wise report
      }
      // ADD: "ATD_NEW_TEST-RO-ALL RIGHTS-ATD::RO",
      // EDIT: "ATD_NEW_TEST-RO-ALL RIGHTS-ATD::RO",
    },
    CAMPAIGNDETAILREPORTS: {
      VIEW: "ATD DASHBOARD-CAMPAIGN DETAIL REPORTS-VIEW-LOGIN :: CAMPAIGN DETAIL REPORTS :: VIEW",
      CAMPAIGNGRAPH: {
        VIEW: "ATD DASHBOARD-CAMPAIGN DETAIL REPORTS-VIEW-LOGIN :: CAMPAIGN DETAIL REPORTS :: CAMPAIGN GRAPH",
      },
      STATISTICS: {
        VIEW: "ATD DASHBOARD-CAMPAIGN DETAIL REPORTS-VIEW-LOGIN :: CAMPAIGN DETAIL REPORTS :: STATISTICS",
      },
      REPORTS: {
        VIEW: "ATD DASHBOARD-CAMPAIGN DETAIL REPORTS-VIEW-LOGIN :: CAMPAIGN DETAIL REPORTS :: REPORTS",
      },
    }


  },
  MEDIAPLAN: {
    MEDIAPLAN: {
      VIEW: "ATD_NEW_TEST-MEDIAPLAN-ALL RIGHTS-ATD::MEDIAPLAN",
      ADD: "ATD_NEW_TEST-MEDIAPLAN-ALL RIGHTS-ATD::MEDIAPLAN",
      DOWNLAOD: "ATD_NEW_TEST-MEDIAPLAN-ALL RIGHTS-ATD::MEDIAPLAN",
    }
  },

  ADMINMARGIN: {
    ADMINMARGIN: {
      VIEW: "ATD_NEW_TEST-ADMINMARGIN-ALL RIGHTS-ATD:ADMINMARGIN",
      ADD: "ATD_NEW_TEST-ADMINMARGIN-ALL RIGHTS-ATD:ADMINMARGIN",
      EDIT: "ATD_NEW_TEST-ADMINMARGIN-ALL RIGHTS-ATD:ADMINMARGIN",
    }
  },

  MARGIN: {
    MARGIN: {
      VIEW: "ATD_NEW_TEST-MARGIN-ALL RIGHTS-ATD::MARGIN",
      ADD: "ATD_NEW_TEST-MARGIN-ALL RIGHTS-ATD::MARGIN",
      EDIT: "ATD_NEW_TEST-MARGIN-ALL RIGHTS-ATD::MARGIN",
    }
  },

  FEESETTING: {
    FEESETTING: {
      VIEW: "ATD FEE SETTING-FEE SETTING-VIEW-LOGIN :: FEE SETTING :: FEE SETTING",
      EDIT: "ATD FEE SETTING-FEE SETTING-EDIT-LOGIN :: FEE SETTING :: FEE SETTING EDIT",
    }
  },

  RO: {
    RO: {
      VIEW: "ATD_NEW_TEST-RO-ALL RIGHTS-ATD::RO",
      ADD: "ATD_NEW_TEST-RO-ALL RIGHTS-ATD::RO",
      EDIT: "ATD_NEW_TEST-RO-ALL RIGHTS-ATD::RO",
    }
  },



  PAYMENT: {
    VIEW: "ATD PAYMENT SUBSCRIPTION-PAYMENT-VIEW-LOGIN :: PAYMENT :: PAYMENT-VIEW",
    ADD: "ATD PAYMENT SUBSCRIPTION-SUBSCRIPTION PLAN-ADD-LOGIN :: PAYMENT SUBSCRIPTION :: SUBSCRIPTION PLAN :: ADD PAYMENT",
    SUBSCRIPTION_PLAN: {
      VIEW: "ATD PAYMENT SUBSCRIPTION-SUBSCRIPTION PLAN-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: SUBSCRIPTION PLAN",
    },
    TRANSACTION_HISTORY: {
      VIEW: "ATD PAYMENT SUBSCRIPTION-TRANSACTION HISTORY-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: TRANSACTION HISTORY",
    },
    INVOICE: {
      VIEW: "ATD PAYMENT SUBSCRIPTION-INVOICE-VIEW-LOGIN :: PAYMENT SUBSCRIPTION :: INVOICE",
    }
  },

  UNMAPPEDCAMPAIGN: {
    UNMAPPEDCAMPAIGN: {
      VIEW: "ATD_NEW_TEST-UNMAPPEDCAMPAIGN-ALL RIGHTS-ATD::UNMAPPED",
      ADD_RO: "ATD_NEW_TEST-UNMAPPEDCAMPAIGN-ALL RIGHTS-ATD::UNMAPPED",
      MAP_RO: "ATD_NEW_TEST-UNMAPPEDCAMPAIGN-ALL RIGHTS-ATD::UNMAPPED",
    }
  },

  OPTIMIZER: {
    OPTIMIZER: {
      VIEW: "ATD OPTIMISER-RECOMMENDATIONS-VIEW-LOGIN :: OPTIMISER :: RECOMMENDATIONS",
      EDIT: "ATD OPTIMISER-RECOMMENDATIONS-EDIT-LOGIN :: OPTIMISER :: RECOMMENDATIONS EDIT"
      // VIEW_RECOMMENDATION: "ATD_NEW_TEST-RECOMMENDATIONS-VIEW-LOGIN :: OPTIMIZER :: RECOMMENDATION :: VIEW RECOMMENDATION",
      // VIEW_HISTORY: "ATD_NEW_TEST-HISTORY-VIEW-LOGIN :: OPTIMIZER :: HISTORY :: VIEW HISTORY",
      // VIEW_RECOMMENDATIONS: "ATD_NEW_TEST-RECOMMENDATIONS-VIEW-LOGIN :: OPTIMIZER :: RECOMMENDATION :: CURRENTRECODETAILS :: VIEW CURRENTRECODETAILS",
      // VIEW_CURRENT_RECOMMENDATION: "ATD_NEW_TEST-RECOMMENDATIONS-VIEW-LOGIN :: OPTIMIZER :: RECOMMENDATION :: CURRENTRECODETAILS :: CURRENT RECO :: VIEW CURRENT RECO",
    }
  },


  CAMPAIGN: {
    CAMPAIGN: {
      VIEW: "ATD CAMPAIGN-CAMPAIGN-VIEW-LOGIN :: CAMPAIGN",
      ADD: "ATD CAMPAIGN-CAMPAIGN-ADD-LOGIN :: ADD CAMPAIGN",
      EDIT: "ATD CAMPAIGN-CAMPAIGN-EDIT-LOGIN :: EDIT CAMPAIGN",
      DELETE: "ATD CAMPAIGN-CAMPAIGN-DELETE-LOGIN :: CAMPAIGN",
    },
  },

  CREATIVE: {
    CREATIVE: {
      VIEW: "ATD CREATIVE-CREATIVE-VIEW-LOGIN :: CREATIVE :: VIEW",
      ADD: "ATD CREATIVE-CREATIVE-ADD-LOGIN :: CREATIVE :: ADD",
      EDIT: "ATD CREATIVE-CREATIVE-EDIT-LOGIN :: CREATIVE :: EDIT"
    }
  },

  ADMIN: {
    VIEW: "ATD ADMIN-ADMIN-VIEW-LOGIN :: ADMIN :: VIEW",
    TENANT: {
      VIEW: "ATD ADMIN-TENANT-VIEW-LOGIN :: ADMIN :: TENANT",
      ADD: "ATD ADMIN-TENANT-ADD-LOGIN :: ADMIN :: TENANT :: MANAGE SERVICE ADD",
      EDIT: "ATD ADMIN-TENANT-EDIT-LOGIN :: ADMIN :: TENANT :: MANAGE SERVICE EDIT",
      MANAGESERVICE: {
        ADD: "ATD ADMIN-TENANT-ADD-LOGIN :: ADMIN :: TENANT :: MANAGE SERVICE ADD",
        EDIT: "ATD ADMIN-TENANT-EDIT-LOGIN :: ADMIN :: TENANT :: MANAGE SERVICE EDIT",
        VIEW: "ATD ADMIN-TENANT-VIEW-LOGIN :: ADMIN :: TENANT :: MANAGE SERVICE VIEW"
      },
      SELFSERVE: {
        ADD: "ATD ADMIN-TENANT-ADD-LOGIN :: ADMIN :: TENANT :: SELF SERVE ADD",
        EDIT: "ATD ADMIN-TENANT-EDIT-LOGIN :: ADMIN :: TENANT :: SELF SERVE EDIT",
        VIEW: "ATD ADMIN-TENANT-VIEW-LOGIN :: ADMIN :: TENANT :: SELF SERVE VIEW"
      }
    },
    PROFILE: {
      VIEW: "ATD ADMIN-PROFILE-VIEW-LOGIN :: ADMIN :: PROFILE",
      ADD: "ATD ADMIN-PROFILE-ADD-LOGIN :: ADMIN :: PROFILE :: ADD PROFILE",
      EDIT: "ATD ADMIN-PROFILE-EDIT-LOGIN :: ADMIN :: PROFILE :: EDIT PROFILE"
    },
    CONNECTIONMANAGEMENT: {
      VIEW: "ATD ADMIN-CONNECTION MANAGEMENT-VIEW-LOGIN :: ADMIN :: CONNECTION MANAGEMENT",
      ADD: "ATD ADMIN-CONNECTION MANAGEMENT-ADD-LOGIN :: ADMIN :: CONNECTION MANAGEMENT :: ADD CONNECTION",
      EDIT: "ATD ADMIN-CONNECTION MANAGEMENT-EDIT-LOGIN :: ADMIN :: CONNECTION MANAGEMENT :: EDIT CONNECTION",
      DELETE: "ATD ADMIN-CONNECTION MANAGEMENT-DELETE-LOGIN :: ADMIN :: CONNECTION MANAGEMENT",
      SYNC: "ATD ADMIN-CONNECTION MANAGEMENT-BACKSYNC-LOGIN :: ADMIN :: CONNECTION MANAGEMENT :: BACK SYNC"
    },
    SUBSCRIPTIONPLANMANAGER: {
      VIEW: "ATD ADMIN-SUBSCRIPTION PLAN MANAGER-VIEW-LOGIN :: ADMIN :: SUBSCRIPTION PLAN MANAGER",
      ADD: "ATD ADMIN-SUBSCRIPTION PLAN MANAGER-ADD-LOGIN :: ADMIN :: SUBSCRIPTION PLAN MANAGER :: ADD SUBSCRIPTION",
      EDIT: "ATD ADMIN-SUBSCRIPTION PLAN MANAGER-EDIT-LOGIN :: ADMIN :: SUBSCRIPTION PLAN MANAGER :: EDIT SUBSCRIPTION"
    },
    DATACONFIG: {
      VIEW: "ATD ADMIN-DATA CONFIG-VIEW-LOGIN :: ADMIN :: DATA CONFIG",
      ADD: "ATD ADMIN-DATA CONFIG-ADD-LOGIN :: ADMIN :: DATA CONFIG :: ADD DATA",
      EDIT: "ATD ADMIN-DATA CONFIG-EDIT-LOGIN :: ADMIN :: DATA CONFIG :: EDIT DATA",
    },
    USERS: {
      VIEW: "ATD ADMIN-USERS-VIEW-LOGIN :: ADMIN :: USER",
      ADD: "ATD ADMIN-USERS-ADD-LOGIN :: ADMIN :: USER :: ADD USER",
      EDIT: "ATD ADMIN-USERS-EDIT-LOGIN :: ADMIN :: USER :: EDIT USER",
      DELETE: "ATD ADMIN-USERS-DELETE-LOGIN :: ADMIN :: USER"
    },
    VARIABLE: {
      VIEW: "ADMIN-VARIABLE-VIEW-LOGIN :: ADMIN :: VARIABLE",
      ADD: "ADMIN-VARIABLE-ADD-LOGIN :: ADMIN :: VARIABLE :: ADD VARIABLE",
      EDIT: "ADMIN-VARIABLE-EDIT-LOGIN :: ADMIN :: VARIABLE :: EDIT VARIABLE",
      DELETE: "ADMIN-VARIABLE-DELETE-LOGIN :: ADMIN :: VARIABLE"
    },
    ADVERTISER: {
      VIEW: "ATD_NEW_TEST-ADVERTISER-ALL RIGHTS-ATD :: ADMIN :: ADVERTISER",
      ADD: "ATD_NEW_TEST-ADVERTISER-ALL RIGHTS-ATD :: ADMIN :: ADVERTISER",
      EDIT: "ATD_NEW_TEST-ADVERTISER-ALL RIGHTS-ATD :: ADMIN :: ADVERTISER",
    },

  },



  AUDIENCE: {
    VIEW: "ATD AUDIENCE-AUDIENCE-VIEW-LOGIN :: AUDIENCE",
    CUSTOMAUDIENCE: {
      VIEW: "ATD AUDIENCE-CUSTOM AUDIENCE-VIEW-LOGIN :: AUDIENCE :: CUSTOM AUDIENCE",
      ADD: "ATD AUDIENCE-CUSTOM AUDIENCE-ADD-LOGIN :: AUDIENCE :: CUSTOM AUDIENCE ADD",
      EDIT: "ATD AUDIENCE-CUSTOM AUDIENCE-EDIT-LOGIN :: AUDIENCE :: CUSTOM AUDIENCE EDIT",
      DELETE: "ATD AUDIENCE-CUSTOM AUDIENCE-DELETE-LOGIN :: AUDIENCE :: CUSTOM AUDIENCE"
    },
    AUDIENCEHIERARCHY: {
      VIEW: "ATD_NEW_TEST-AUDIENCE HIERARCHY-ALL RIGHTS-ATD :: AUDIENCE :: AUDIENCE HIERARCHY",
      EDIT: "ATD_NEW_TEST-AUDIENCE HIERARCHY-ALL RIGHTS-ATD :: AUDIENCE :: AUDIENCE HIERARCHY"
    },
    HIERARCHYMANAGER: {
      VIEW: "ATD_NEW_TEST-HIERARCHY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: HIERARCHY MANAGER",
      ADD: "ATD_NEW_TEST-HIERARCHY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: HIERARCHY MANAGER",
      EDIT: "ATD_NEW_TEST-HIERARCHY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: HIERARCHY MANAGER",
      DELETE: "ATD_NEW_TEST-HIERARCHY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: HIERARCHY MANAGER"
    },
    APR: {
      VIEW: "AUDIENCE-APR-VIEW-LOGIN :: AUDIENCE :: APR",
      ADD: "AUDIENCE-APR-ADD-LOGIN AUDIENCE :: APR AUDIENCE :: CREATE NEW APR",
      EDIT: "AUDIENCE-APR-EDIT-LOGIN AUDIENCE :: APR AUDIENCE :: EDIT  APR",
      DOWNLOAD: "AUDIENCE-APR-DOWNLOAD-LOGIN :: AUDIENCE :: APR"
    },
    TAXONOMYMANAGER: {
      VIEW: "ATD_NEW_TEST-TAXONOMY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: TAXONOMY MANAGER",
      ADD: "ATD_NEW_TEST-TAXONOMY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: TAXONOMY MANAGER",
      EDIT: "ATD_NEW_TEST-TAXONOMY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: TAXONOMY MANAGER",
      DELETE: "ATD_NEW_TEST-TAXONOMY MANAGER-ALL RIGHTS-ATD :: AUDIENCE :: TAXONOMY MANAGER"
    },
    DATACAPTURE: {
      VIEW: "ATD_NEW_TEST-DATA CAPTURE-ALL RIGHTS-ATD :: AUDIENCE :: DATA CAPTURE",
      ADD: "ATD_NEW_TEST-DATA CAPTURE-ALL RIGHTS-ATD :: AUDIENCE :: DATA CAPTURE",
      EDIT: "ATD_NEW_TEST-DATA CAPTURE-ALL RIGHTS-ATD :: AUDIENCE :: DATA CAPTURE",
      DELETE: "ATD_NEW_TEST-DATA CAPTURE-ALL RIGHTS-ATD :: AUDIENCE :: DATA CAPTURE",
      DOWNLOAD: "ATD_NEW_TEST-DATA CAPTURE-ALL RIGHTS-ATD :: AUDIENCE :: DATA CAPTURE"
    }
  },
  AUDIENCE_MARKET_PLACE: {
    VIEW: "ATD AUDIENCE MARKET PLACE-AUDIENCE MARKET PLACE-VIEW-LOGIN :: AUDIENCE MARKET PLACE :: VIEW",
    BRIEF: {
      VIEW: "ATD AUDIENCE MARKET PLACE-BRIEF-VIEW-LOGIN :: AUDIENCE MARKET PLACE :: BRIEF"
    },
    MEDIAPLAN: {
      VIEW: "ATD AUDIENCE MARKET PLACE-MEDIA PLAN-VIEW-LOGIN :: AUDIENCE MARKET PLACE :: MEDIA PLAN"
    },
    RO: {
      VIEW: "ATD AUDIENCE MARKET PLACE-RO-VIEW-LOGIN :: AUDIENCE MARKET PLACE :: RO"
    },
    CAMPAIGNCREATION: {
      VIEW: "ATD AUDIENCE MARKET PLACE-CAMPAIGN CREATION-VIEW-LOGIN :: AUDIENCE MARKET PLACE :: CAMPAIGN CREATION"
    }
  }








}


export const MODULE_PERMISSIONS = {
  // DASHBOARD: [
  //   PERMISSION.DASHBOARD.DASHBOARDREPORT.ATDREPORT.VIEW,
  // ],
  DASHBOARD: [
    PERMISSION.DASHBOARD.DASHBOARD.VIEW
  ],
  DASHBOARD_DATAWISE: [
    PERMISSION.DASHBOARD.DASHBOARD.DATAWISEREPORT.VIEW
  ],
  DASHBOARD_IMPRESSION_SPEND_GRAPH: [
    PERMISSION.DASHBOARD.DASHBOARD.IMPRESSIONGRAPH.VIEW
  ],
  DASHBOARD_STATISTICS: [
    PERMISSION.DASHBOARD.DASHBOARD.STATISTICS.VIEW
  ],
  DASHBOARD_CAMPAIGNPERFORMANCEVIEW: [
    PERMISSION.DASHBOARD.DASHBOARD.CAMPAIGNPERFORMANCEVIEW.VIEW
  ],
  DASHBOARD_CAMPAIGNVIEW: [
    PERMISSION.DASHBOARD.DASHBOARD.CAMPAIGNVIEW.VIEW
  ],
  DASHBOARD_CAMPAIGNREPORTVIEW: [
    PERMISSION.DASHBOARD.DASHBOARD.CAMPAIGNREPORTVIEW.VIEW
  ],
  DASHBOARD_IOREPORTVIEW: [
    PERMISSION.DASHBOARD.DASHBOARD.IOREPORTVIEW.VIEW
  ],

  MEDIAPLAN: [
    PERMISSION.MEDIAPLAN.MEDIAPLAN.VIEW
  ],
  ADMINMARGIN: [
    PERMISSION.ADMINMARGIN.ADMINMARGIN.VIEW
  ],

  MARGIN: [
    PERMISSION.MARGIN.MARGIN.VIEW
  ],

  FEESETTING: [
    PERMISSION.FEESETTING.FEESETTING.VIEW
  ],

  RO: [
    PERMISSION.RO.RO.VIEW
  ],

  ADMIN_DATACONFIG: [
    PERMISSION.ADMIN.DATACONFIG.VIEW
  ],

  PAYMENT: [
    PERMISSION.PAYMENT.VIEW,
    // PERMISSION.PAYMENT.SUBSCRIPTION_PLAN.VIEW,
    // PERMISSION.PAYMENT.TRANSACTION_HISTORY.VIEW,
    // PERMISSION.PAYMENT.INVOICE.VIEW
  ],

  PAYMENT_SUBSCRIPTION_PLAN: [PERMISSION.PAYMENT.SUBSCRIPTION_PLAN.VIEW],
  PAYMENT_TRANSACTION_HISTORY: [PERMISSION.PAYMENT.TRANSACTION_HISTORY.VIEW],
  PAYMENT_INVOICE: [PERMISSION.PAYMENT.INVOICE.VIEW],

  UNMAPPEDCAMPAIGN: [
    PERMISSION.UNMAPPEDCAMPAIGN.UNMAPPEDCAMPAIGN.VIEW
  ],

  OPTIMIZER: [
    PERMISSION.OPTIMIZER.OPTIMIZER.VIEW
  ],

  CAMPAIGN: [
    PERMISSION.CAMPAIGN.CAMPAIGN.VIEW
  ],

  CREATIVE: [PERMISSION.CREATIVE.CREATIVE.VIEW],
  ADMIN: [
    PERMISSION.ADMIN.VIEW,
  ],
  ADMIN_TENANT: [PERMISSION.ADMIN.TENANT.VIEW],
  ADMIN_PROFILE: [PERMISSION.ADMIN.PROFILE.VIEW],
  ADMIN_SUBSCRIPTION_PLAN_MANAGER: [PERMISSION.ADMIN.SUBSCRIPTIONPLANMANAGER.VIEW],
  ADMIN_USERS: [PERMISSION.ADMIN.USERS.VIEW],
  ADMIN_CONNECTION_MANAGEMENT: [PERMISSION.ADMIN.CONNECTIONMANAGEMENT.VIEW],
  ADMIN_VARIABLE: [PERMISSION.ADMIN.VARIABLE.VIEW],
  ADMIN_ADVERTISER: [PERMISSION.ADMIN.ADVERTISER.VIEW],
  AUDIENCE: [
    PERMISSION.AUDIENCE.CUSTOMAUDIENCE.VIEW,
    PERMISSION.AUDIENCE.AUDIENCEHIERARCHY.VIEW,
    PERMISSION.AUDIENCE.HIERARCHYMANAGER.VIEW,
    PERMISSION.AUDIENCE.APR.VIEW,
    PERMISSION.AUDIENCE.TAXONOMYMANAGER.VIEW,
    PERMISSION.AUDIENCE.DATACAPTURE.VIEW,
  ],

  AUDIENCE_HIERARCHY: [PERMISSION.AUDIENCE.AUDIENCEHIERARCHY.VIEW],
  AUDIENCE_HIERARCHYMANAGER: [PERMISSION.AUDIENCE.HIERARCHYMANAGER.VIEW],
  AUDIENCE_APR: [PERMISSION.AUDIENCE.APR.VIEW],
  AUDIENCE_TAXONOMYMANAGER: [PERMISSION.AUDIENCE.TAXONOMYMANAGER.VIEW],
  AUDIENCE_DATACAPTURE: [PERMISSION.AUDIENCE.DATACAPTURE.VIEW],
  CUSTOM_AUDIENCE: [PERMISSION.AUDIENCE.CUSTOMAUDIENCE.VIEW]
  ,
  AUDIENCE_MARKET_PLACE: [
    PERMISSION.AUDIENCE_MARKET_PLACE.VIEW
  ],
  AUDIENCE_MARKETPLACE_BRIEF: [
    PERMISSION.AUDIENCE_MARKET_PLACE.BRIEF.VIEW
  ],
  AUDIENCE_MARKETPLACE_MEDIA_PLAN: [
    PERMISSION.AUDIENCE_MARKET_PLACE.MEDIAPLAN.VIEW
  ],
  AUDIENCE_MARKETPLACE_RO: [
    PERMISSION.AUDIENCE_MARKET_PLACE.RO.VIEW
  ],
  AUDIENCE_MARKETPLACE_CAMPAIGN_CREATION: [
    PERMISSION.AUDIENCE_MARKET_PLACE.CAMPAIGNCREATION.VIEW
  ],






}
